import { useState } from "react";
import StaffTabs from "@/components/backoffice/all-staff/payroll/staff-tabs";
import Layout2 from "../../../../../components/Layout/Layout2";
import LeftBar2 from "../../../../../components/Layout/LeftBar2";
import { backofficeLinks } from "../../../../../components/lib/SidebarLinks";
import PayrollHistoryTabs from "@/components/backoffice/all-staff/payroll/payroll-history-tabs";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import hasPermission from "@/hooks/hasPermission";

function Payroll() {
  const hasAttendance = hasPermission("back_office.staff_management.staff_attendance");
  const hasPayroll = hasPermission("back_office.staff_management.staff_payroll");

  const defaultTab = hasAttendance ? "staff" : (hasPayroll ? "payroll-history" : "");
  const [activeTab, setActiveTab] = useState(defaultTab);

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
      pageName={{ title: "Payroll" }}
      paths={[
        { name: "Back Office", path: "/backoffice/overview" },
        {
          name: "Staff Management",
          path: "/backoffice/staff-management/staff/all",
        },
        {
          name: "Payroll",
          path: "/backoffice/staff-management/payroll",
        },
      ]}
    >
      <div className="container flex flex-col 4">
        <Tabs
          valueKey="staff-manage-payroll"
          tabName="default"
          defaultValue={defaultTab}
          onValueChange={setActiveTab}
          className="w-full mt-5"
        >
          <TabsList className="h-auto w-full justify-start rounded-none border-b border-white/20 bg-transparent p-0">
            {hasAttendance && (
              <TabsTrigger
                value="staff"
                className="border-r border-white/25 px-4 py-2 text-sm font-medium text-cwhite2 data-[state=active]:border-b-2 data-[state=active]:border-cyellow data-[state=active]:text-cyellow bg-transparent"
              >
                Staff
              </TabsTrigger>
            )}
            {hasPayroll && (
              <TabsTrigger
                value="payroll-history"
                className="px-4 py-2 text-sm font-medium text-cwhite2 data-[state=active]:border-b-2 data-[state=active]:border-cyellow data-[state=active]:text-cyellow bg-transparent"
              >
                Payroll History
              </TabsTrigger>
            )}
          </TabsList>
          {hasAttendance && activeTab === "staff" && <StaffTabs />}
          {hasPayroll && activeTab === "payroll-history" && <PayrollHistoryTabs />}
        </Tabs>
      </div>
    </Layout2>
  );
}

export default Payroll;
